import { render } from "./ElectionOfficers.vue?vue&type=template&id=7c3fb4d2&scoped=true"
import script from "./ElectionOfficers.vue?vue&type=script&lang=js"
export * from "./ElectionOfficers.vue?vue&type=script&lang=js"

import "./ElectionOfficers.vue?vue&type=style&index=0&id=7c3fb4d2&scoped=true&lang=css"

import exportComponent from "C:\\Users\\shuha\\Documents\\Wisdom guide front\\wg-frontend-v1\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c3fb4d2"]])

export default __exports__